import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { httpsCallable } from 'firebase/functions';
import { FUNCTIONS_TOKEN } from '../firebase/functions.provider';
import { AuthService } from './auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';

export const uuidSignInGuard: CanActivateFn = async (route) => {
  const uuid = route.paramMap.get('uuid');
  const router = inject(Router);

  if (!uuid) {
    return router.parseUrl('/sign-in');
  }

  const functions = inject(FUNCTIONS_TOKEN);
  const authService = inject(AuthService);
  const injector = inject(Injector);

  try {
    const getCustomToken = httpsCallable<{ uuid: string }, { token: string }>(functions, 'getCustomTokenByUuid');
    const result = await getCustomToken({ uuid });

    if (result.data && typeof result.data.token === 'string') {
      // カスタムクレームの解決を待機するためのObservable
      const isAuthResolved$ = toObservable(authService.isAuthResolved, { injector });

      await authService.signInWithCustomToken(result.data.token);
      
      await firstValueFrom(isAuthResolved$.pipe(filter(resolved => resolved === true)));
      
      // ロールの検証 (UUIDログインは viewer 権限でのみ許可)
      const role = authService.userRole();
      if (role !== 'viewer') {
        console.error(`Invalid role for UUID sign in: ${role}`);
        await authService.signOut();
        return router.parseUrl('/sign-in');
      }
      
      return true;
    } else {
      console.error('Invalid response from getCustomTokenByUuid');
    }
  } catch (error) {
    console.error('Failed to sign in via UUID', error);
  }

  return router.parseUrl('/sign-in');
};
